<template>
  <section class="listing">
    <div class="header">
      <div class="title">Vídeos educacionais</div>
      <button @click="$router.push('/educational-video/new')" class="button-new button-add"><i class="fas fa-plus"></i><span>NOVO</span></button>
    </div>
    <form @submit.prevent class="form" style="padding: 0 0 15px">
      <div class="search-input">
        <input v-model="search" type="text" placeholder="Pesquisar..." />
        <i class="fas fa-search show-search"></i>
      </div>
      <select v-model="filterPlatform" style="margin-top: 10px; max-width: 280px">
        <option value="">Todas as plataformas</option>
        <option v-for="opt in platformOptions" :key="opt.value" :value="opt.value">{{ opt.text }}</option>
      </select>
    </form>
    <transition name="show" mode="out-in">
      <i v-if="loading" class="fas fa-spinner loading-big"></i>
      <div v-if="!loading">
        <div v-for="v in filtered" :key="v.id" class="list">
          <div class="data">
            <div class="main-data">{{ v.title }}</div>
            <div class="detail-data">{{ platformLabel(v.platform) }}</div>
            <div class="detail-data video-url">{{ v.youtubeUrl }}</div>
            <div class="detail-data">
              <span :class="{ inactive: !v.active }">{{ v.active ? 'ATIVO' : 'INATIVO' }}</span>
            </div>
          </div>
          <div class="actions">
            <button @click="$router.push(`/educational-video/${v.id}`)" class="button-action"><i class="fas fa-pen"></i><span>ALTERAR</span></button>
            <button @click="confirmRemove(v)" class="button-action"><i class="fas fa-trash-alt"></i><span>EXCLUIR</span></button>
          </div>
        </div>
        <div v-if="filtered.length === 0" class="detail-data" style="padding: 15px">Nenhum vídeo cadastrado.</div>
      </div>
    </transition>
    <EducationalVideo v-if="videoId" :id="videoId" />
  </section>
</template>

<script>
import logger from '../../logger'
import { getAll, remove } from '../api/educationalVideo'
import EducationalVideo from './EducationalVideo.vue'

const PLATFORM_OPTIONS = [
  { value: 'profit', text: 'Profit' },
  { value: 'blackarrow', text: 'BlackArrow' },
  { value: 'ninjatrader', text: 'NinjaTrader' },
  { value: 'tradingview', text: 'TradingView' },
  { value: 'profit_yan', text: 'Profit Yan' },
  { value: 'blackarrow_yan', text: 'BlackArrow Yan' },
  { value: 'ninjatrader_yan', text: 'NinjaTrader Yan' }
]

const PLATFORM_LABELS = Object.fromEntries(PLATFORM_OPTIONS.map(o => [o.value, o.text]))

export default {
  name: 'EducationalVideos',
  components: { EducationalVideo },
  props: ['id'],
  data () {
    return {
      loading: true,
      videos: [],
      search: '',
      filterPlatform: '',
      videoId: null,
      platformOptions: PLATFORM_OPTIONS
    }
  },
  computed: {
    filtered () {
      let list = this.videos
      if (this.filterPlatform) {
        list = list.filter(v => v.platform === this.filterPlatform)
      }
      if (!this.search.trim()) return list
      const q = this.search.toUpperCase()
      return list.filter(v => Object.keys(v).some(key => String(v[key]).toUpperCase().includes(q)))
    }
  },
  watch: {
    '$route' (value) {
      this.videoId = value.params.id || null
      if (!value.params.id) this.getData()
    }
  },
  async mounted () {
    this.videoId = this.id || null
    await this.getData()
  },
  methods: {
    platformLabel (platform) {
      return PLATFORM_LABELS[platform] || platform || ''
    },
    async getData () {
      try {
        this.loading = true
        this.videos = await getAll()
      } catch (e) {
        logger.error(e, this)
      } finally {
        this.loading = false
      }
    },
    async confirmRemove (video) {
      if (!window.confirm(`Excluir o vídeo "${video.title}"?`)) return
      try {
        await remove(video.id)
        await this.getData()
      } catch (e) {
        logger.error(e, this)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.button-add {
  position: relative !important;
  bottom: auto !important;
  right: auto !important;
  z-index: 0 !important;
}
.video-url {
  font-size: 0.85em;
  word-break: break-all;
  opacity: 0.85;
}
.inactive {
  color: #c0392b;
}
.search-input {
  min-width: 200px;
  position: relative;
  input {
    width: 100%;
  }
  i {
    position: absolute;
    top: 11px;
    right: 6px;
    color: #666;
    font-size: 1.5em;
  }
}
</style>
